// A labelled address a conversation is exported to in one click. Fuzey staff
// set the list per merchant; the label is what the agent sees.
export default class ExportDestination {
  label: string;

  email: string;

  constructor(label: string, email: string) {
    this.label = label;
    this.email = email;
  }
}
